export enum Role {
  FCA_ADMIN = 'FCA_ADMIN',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  CLIENT_USER = 'CLIENT_USER',
  CLIENT_OSR = 'CLIENT_OSR',
  WORKER = 'WORKER',
}

export interface IUser {
  fullName?: string;
  username?: string;
  email?: string;
  mobilePhoneNumber?: string;
  companyUserId?: string;
  companyWorkerId?: string;
  currentCompanyId?: string;
  isFcaUser: boolean;
  isAdmin: boolean;
  isAdminOnAnyProject?: boolean;
  isSuperAdmin?: boolean;
  isWorker?: boolean;
  isOsr?: boolean;
  isAdminSession?: boolean;
  workerId?: string;
  userId?: string;
  permissions: any[];
}
